import {appHost} from "./constants.js";


var config = null;

export default async function(){
	
	if(config == null){
		let res = await fetch(`${appHost}/config`);
		config = await res.json();
	}
	return config;
}